<template>
  <NBox dir="rtl" class="h-full" :class="{ 'overflow-y-scroll': !vertical }">
    <NBox
      v-if="!vertical"
      class="flex justify-between items-center pt-3 px-2"
      elevation="none"
    >
      <SymbolInfoCard :symbol="symbol" :is-market-map="isMarketMap" />
    </NBox>

    <div class="px-2 py-2">
      <NButtonToggleGroup
        :model-value="selectedToggleButton"
        color="gray"
        class="w-full"
      >
        <NButtonToggle
          :model-value="SYNBOL_SUMMARY_TOGGLE_BUTTON_ID.symbolDetail"
          :label="t('modules.order.symbol_detail')"
          class="w-full"
          @click="
            handleToggleButton(SYNBOL_SUMMARY_TOGGLE_BUTTON_ID.symbolDetail)
          "
        />

        <NButtonToggle
          :model-value="SYNBOL_SUMMARY_TOGGLE_BUTTON_ID.symbolChart"
          :label="t('symbol.charts.title')"
          class="w-full"
          @click="
            handleToggleButton(SYNBOL_SUMMARY_TOGGLE_BUTTON_ID.symbolChart)
          "
        />
      </NButtonToggleGroup>
    </div>

    <SymbolTradeInfo
      v-if="
        selectedToggleButton === SYNBOL_SUMMARY_TOGGLE_BUTTON_ID.symbolDetail
      "
      :symbol="symbol"
      :portfolio-detail="portfolioQuantity"
      :vertical="vertical"
    />

    <SymbolChart
      v-if="
        selectedToggleButton === SYNBOL_SUMMARY_TOGGLE_BUTTON_ID.symbolChart
      "
    />
  </NBox>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import type { Instrument, PortfolioItem } from '@libs/api-reference';
import { useI18n } from 'vue-i18n';

import {
  SymbolInfoCard,
  SymbolTradeInfo,
  SymbolChart,
  SYNBOL_SUMMARY_TOGGLE_BUTTON_ID,
} from '@/modules/symbol';

const props = withDefaults(
  defineProps<{
    symbol: Instrument;
    portfolioSymbols?: PortfolioItem[] | null;
    vertical?: boolean;
    isMarketMap?: boolean;
  }>(),
  {
    vertical: false,
    portfolioSymbols: () => [],
    isMarketMap: false,
  }
);

const { t } = useI18n();

const selectedToggleButton = ref(SYNBOL_SUMMARY_TOGGLE_BUTTON_ID.symbolDetail);

const portfolioQuantity = computed(() => {
  if (props.portfolioSymbols) {
    const symbol = props.portfolioSymbols?.find(
      (portfolioSymbol) => portfolioSymbol.instrumentIsin === props.symbol.isin
    );

    return {
      quantity: symbol?.quantity ?? 0,
      percentageValue: symbol?.returnValuePercentage ?? 0,
    };
  }

  return null;
});

const handleToggleButton = (id: number) => {
  selectedToggleButton.value = id;
};
</script>
